import {
  Grid,
  Typography,
  Divider,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { sxStyled } from './styles';
import UseCurrency from '@shared/hooks/UseCurrency';

const BestFastConvenient = ({ data, handleScroll, selectedId }) => {
  const theme = useTheme();

  const { currency } = UseCurrency();

  const { cheapest, fastest, convenient } = data;

  const sxStyle = sxStyled(theme);
  const matches = useMediaQuery(theme.breakpoints.down('xs'));

  const getFastestInCluster = arr => {
    let min = arr?.[0]?.flight_time;

    arr?.forEach(el => {
      if (el.flight_time < min) {
        min = el.flight_time;
      }
    });

    return min;
  };

  const flightTimeConvert = num => {
    let hours = Math.floor(num / 60);
    let minutes = num % 60;
    return `${hours}h ${minutes}m`;
  };

  return (
    <Grid container justifyContent="space-evenly" sx={sxStyle.root}>
      <Grid
        item
        xs={12}
        sm={3}
        sx={{
          ...sxStyle.box,
          ...(selectedId === cheapest.cluster_id ? sxStyle.active : {}),
        }}
        onClick={() => {
          handleScroll(cheapest);
        }}
      >
        <Typography sx={sxStyle.boxTitle}>Más barato</Typography>
        <Typography sx={sxStyle.boxPrice}>
          {cheapest == undefined ? (
            <Skeleton variant="text" />
          ) : (
            currency(cheapest?.cluster?.composition_price?.total)
          )}
        </Typography>
        <Typography sx={sxStyle.boxInfo}>
          Tiempo de ida:{' '}
          {cheapest == undefined ? (
            <Skeleton variant="text" />
          ) : (
            flightTimeConvert(getFastestInCluster(cheapest?.legs[0].options))
          )}
        </Typography>
        {cheapest?.legs.length == '2' && (
          <Typography sx={sxStyle.boxInfo}>
            Tiempo de Vuelta:{' '}
            {cheapest == undefined ? (
              <Skeleton variant="text" />
            ) : (
              flightTimeConvert(getFastestInCluster(cheapest?.legs[1].options))
            )}
          </Typography>
        )}
      </Grid>
      <Divider
        xs={4}
        sm={1}
        orientation={matches ? 'horizontal' : 'vertical'}
        sx={sxStyle.divider}
      />
      <Grid
        item
        xs={12}
        sm={3}
        sx={{
          ...sxStyle.box,
          ...(selectedId === convenient.cluster_id ? sxStyle.active : {}),
        }}
        onClick={() => {
          handleScroll(convenient);
        }}
      >
        <Typography sx={sxStyle.boxTitle}>Más conveniente</Typography>
        <Typography sx={sxStyle.boxPrice}>
          {convenient == undefined ? (
            <Skeleton variant="text" />
          ) : (
            currency(convenient?.cluster?.composition_price?.total)
          )}
        </Typography>
        <Typography sx={sxStyle.boxInfo}>
          Tiempo de ida:{' '}
          {convenient == undefined ? (
            <Skeleton variant="text" />
          ) : (
            flightTimeConvert(getFastestInCluster(convenient?.legs[0].options))
          )}
        </Typography>
        {convenient?.legs.length == '2' && (
          <Typography sx={sxStyle.boxInfo}>
            Tiempo de Vuelta:{' '}
            {convenient == undefined ? (
              <Skeleton variant="text" />
            ) : (
              flightTimeConvert(
                getFastestInCluster(convenient?.legs[1].options)
              )
            )}
          </Typography>
        )}
      </Grid>
      <Divider
        xs={4}
        sm={1}
        orientation={matches ? 'horizontal' : 'vertical'}
        sx={sxStyle.divider}
      />
      <Grid
        item
        xs={12}
        sm={3}
        sx={{
          ...sxStyle.box,
          ...(selectedId === fastest.cluster_id ? sxStyle.active : {}),
        }}
        onClick={() => handleScroll(fastest)}
      >
        <Typography sx={sxStyle.boxTitle}>Más rápido</Typography>
        <Typography sx={sxStyle.boxPrice}>
          {fastest == undefined ? (
            <Skeleton variant="text" />
          ) : (
            currency(fastest?.cluster?.composition_price?.total)
          )}
        </Typography>
        <Typography sx={sxStyle.boxInfo}>
          Tiempo de ida:{' '}
          {fastest == undefined ? (
            <Skeleton variant="text" />
          ) : (
            flightTimeConvert(getFastestInCluster(fastest?.legs?.[0]?.options))
          )}
        </Typography>
        {cheapest?.legs.length == '2' && (
          <Typography sx={sxStyle.boxInfo}>
            Tiempo de vuelta:{' '}
            {fastest == undefined ? (
              <Skeleton variant="text" />
            ) : (
              flightTimeConvert(
                getFastestInCluster(fastest?.legs?.[1]?.options)
              )
            )}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default BestFastConvenient;
